import { MouseEvent, useState } from 'react';

export function useHandlePopper() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);
  const [openPopper, setOpenPopper] = useState(false);

  const handleOpen = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper(!openPopper);
  };

  return {
    handleOpen,
    setOpenPopper,
    setAnchorEl,
    openPopper,
    anchorEl,
  };
}
